import { BUTTON_TYPE } from '../../../constants/constant';
import { TEXT_KEYS } from '../../../constants/textKeys';
import IMAGES_PATH from '../../../Images';
import { t } from '../../../translation/translation';
import { Button } from '../../common/Button';
import './style.css'

const SectionSignUp = () => {

    const buttonLabel = "Sign Up";
    const title = "Welcome to Our Service";
    const subtitle = "Join us today!";


    return (
        <div className='section'>
            <div
                className='section-sign-up-container'
            >
                <div
                    className='section-sign-up-image'
                    style={{
                        backgroundImage: `url(${IMAGES_PATH.BACKGROUND_DOODLE})`,
                    }}
                >
                    <h4 className='text-white section-sign-up-subtitle'>{t(TEXT_KEYS.SIGN_UP_SECTION_SUBTITLE)}</h4>
                    <h2 className='text-white section-sign-up-title'>{t(TEXT_KEYS.SIGN_UP_SECTION_TITLE)}</h2>

                    <div className='section-sign-up-input-container'>
                        <input
                            className='section-sign-up-input'
                            type="email"
                            placeholder={t(TEXT_KEYS.EMAIL)}
                            required
                        />
                        <Button
                            label={buttonLabel}
                            type={BUTTON_TYPE.PRIMARY}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SectionSignUp;